<template>
  <div>
    <app-cells><h1 class="title">Rental items</h1></app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'RentalItemsLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'rental-items-active', label: 'Active' },
        { name: 'rental-items-repair', label: 'Need repair' },
        { name: 'rental-items-destroyed', label: 'Destroyed / Lost' },
      ]
    }
  },
}
</script>
